import {
	cibSkype,
	cibFacebook,
	cibTwitter,
	cibLinkedin,
	cibFlickr,
	cibTumblr,
	cibXing,
	cibGithub,
	cibStackoverflow,
	cibYoutube,
	cibDribbble,
	cibInstagram,
	cibPinterest,
	cibVk,
	cibYahoo,
	cibBehance,
	cibReddit,
	cibVimeo,
	cibCcMastercard,
	cibCcVisa,
	cibStripe,
	cibPaypal,
	cibGooglePay,
	cibCcAmex,
	cifUs,
	cifBr,
	cifIn,
	cifFr,
	cifEs,
	cifPl,
	cifRu,
	cil3d,
	cilAccountLogout,
	cilActionUndo,
	cilAlignCenter,
	cilAlignLeft,
	cilAlignRight,
	cilApplicationsSettings,
	cilArrowRight,
	cilArrowLeft,
	cilArrowTop,
	cilArrowThickToLeft,
	cilAsterisk,
	cilBan,
	cilBank,
	cilBasket,
	cilBalanceScale,
	cilBell,
	cilBold,
	cilBook,
	cilBookmark,
	cilBuilding,
	cilCalculator,
	cilCalendar,
	cilCart,
	cilCaretBottom,
	cilCash,
	cilClipboard,
	cilCloudDownload,
	cilCloudUpload,
	cilChartPie,
	cilChartLine,
	cilCheck,
	cilCheckAlt,
	cilChevronBottom,
	cilChevronLeft,
	cilChevronRight,
	cilChevronTop,
	cilCircle,
	cilCheckCircle,
	cilCode,
	cilCommentSquare,
	cilCreditCard,
	cilCursor,
	cilCursorMove,
	cilCut,
	cilDescription,
	cilDrop,
	cilDollar,
	cilEnvelopeClosed,
	cilEnvelopeLetter,
	cilEnvelopeOpen,
	cilEuro,
	cilExitToApp,
	cilExpandDown,
	cilExpandUp,
	cilGlobeAlt,
	cilGrid,
	cilFile,
	cilFilter,
	cilFindInPage,
	cilFolderOpen,
	cilFolder,
	cilFullscreen,
	cilFullscreenExit,
	cilGraph,
	cilHome,
	cilInbox,
	cilImagePlus,
	cilIndentDecrease,
	cilIndentIncrease,
	cilInputPower,
	cilItalic,
	cilJustifyCenter,
	cilJustifyLeft,
	cilLanguage,
	cilLaptop,
	cilLayers,
	cilLibraryAdd,
	cilLibrary,
	cilLightbulb,
	cilList,
	cilListNumbered,
	cilListRich,
	cilLocationPin,
	cilLockLocked,
	cilLoop,
	cilMagnifyingGlass,
	cilMap,
	cilMoon,
	cilMoney,
	cilMinus,
	cilNewspaper,
	cilNotes,
	cilNoteAdd,
	cilOptions,
	cilPaint,
	cilPaperclip,
	cilPaperPlane,
	cilPencil,
	cilPeople,
	cilPhone,
	cilPlus,
	cilPrint,
	cilPuzzle,
	cilReload,
	cilRuble,
	cilSave,
	cilScrubber,
	cilSettings,
	cilShare,
	cilShareAll,
	cilShareBoxed,
	cilShieldAlt,
	cilSpeech,
	cilSpeedometer,
	cilSpreadsheet,
	cilStar,
	cilSun,
	cilSwapVertical,
	cilTags,
	cilTask,
	cilTrash,
	cilUnderline,
	cilUser,
	cilUserFemale,
	cilUserFollow,
	cilUserUnfollow,
	cilX,
	cilXCircle,
	cilWarning,
	cilWallet
} from '@coreui/icons';

import { logo } from './logo';
import { logoNegative } from './logo-negative';
import { sygnet } from './sygnet';

export const icons = Object.assign(
	{},
	{
		sygnet,
		logo,
		logoNegative
	},
	{
		cil3d,
		cilAccountLogout,
		cilActionUndo,
		cilAlignCenter,
		cilAlignLeft,
		cilAlignRight,
		cilApplicationsSettings,
		cilArrowRight,
		cilArrowLeft,
		cilArrowTop,
		cilArrowThickToLeft,
		cilAsterisk,
		cilBan,
		cilBank,
		cilBasket,
		cilBalanceScale,
		cilBell,
		cilBold,
		cilBook,
		cilBookmark,
		cilBuilding,
		cilCalculator,
		cilCalendar,
		cilCart,
		cilCaretBottom,
		cilCash,
		cilClipboard,
		cilCloudDownload,
		cilCloudUpload,
		cilChartPie,
		cilChartLine,
		cilCheck,
		cilCheckAlt,
		cilChevronBottom,
		cilChevronLeft,
		cilChevronRight,
		cilChevronTop,
		cilCircle,
		cilCheckCircle,
		cilCode,
		cilCommentSquare,
		cilCreditCard,
		cilCursor,
		cilCursorMove,
		cilCut,
		cilDescription,
		cilDrop,
		cilDollar,
		cilEnvelopeClosed,
		cilEnvelopeLetter,
		cilEnvelopeOpen,
		cilEuro,
		cilExitToApp,
		cilExpandDown,
		cilExpandUp,
		cilGlobeAlt,
		cilGrid,
		cilFile,
		cilFilter,
		cilFindInPage,
		cilFolderOpen,
		cilFolder,
		cilFullscreen,
		cilFullscreenExit,
		cilGraph,
		cilHome,
		cilImagePlus,
		cilInbox,
		cilIndentDecrease,
		cilIndentIncrease,
		cilInputPower,
		cilItalic,
		cilJustifyCenter,
		cilJustifyLeft,
		cilLanguage,
		cilLaptop,
		cilLayers,
		cilLibraryAdd,
		cilLibrary,
		cilLightbulb,
		cilList,
		cilListNumbered,
		cilListRich,
		cilLocationPin,
		cilLockLocked,
		cilLoop,
		cilMagnifyingGlass,
		cilMap,
		cilMoon,
		cilMoney,
		cilMinus,
		cilNewspaper,
		cilNoteAdd,
		cilNotes,
		cilOptions,
		cilPaint,
		cilPaperclip,
		cilPaperPlane,
		cilPencil,
		cilPeople,
		cilPhone,
		cilPlus,
		cilPrint,
		cilPuzzle,
		cilReload,
		cilRuble,
		cilSave,
		cilScrubber,
		cilSettings,
		cilShare,
		cilShareAll,
		cilShareBoxed,
		cilShieldAlt,
		cilSpeech,
		cilSpeedometer,
		cilSpreadsheet,
		cilStar,
		cilSun,
		cilSwapVertical,
		cilTags,
		cilTask,
		cilTrash,
		cilUnderline,
		cilUser,
		cilUserFemale,
		cilUserFollow,
		cilUserUnfollow,
		cilX,
		cilXCircle,
		cilWarning,
		cilWallet
	},
	{
		cifUs,
		cifBr,
		cifIn,
		cifFr,
		cifEs,
		cifPl,
		cifRu
	},
	{
		cibSkype,
		cibFacebook,
		cibTwitter,
		cibLinkedin,
		cibFlickr,
		cibTumblr,
		cibXing,
		cibGithub,
		cibStackoverflow,
		cibYoutube,
		cibDribbble,
		cibInstagram,
		cibPinterest,
		cibVk,
		cibYahoo,
		cibBehance,
		cibReddit,
		cibVimeo,
		cibCcMastercard,
		cibCcVisa,
		cibStripe,
		cibPaypal,
		cibGooglePay,
		cibCcAmex
	}
);
